document.addEventListener('DOMContentLoaded', function () {
  const bundleWrapper = document.querySelector('.nesteva-olla-bundle');
  const productForm = document.querySelector('form.product-single__form');

  if (!bundleWrapper) return;

  const bundleButtons = bundleWrapper.querySelectorAll('.bundle-btn');
  const pickerContent = bundleWrapper.querySelector('.bundle-content-picker');
  const bundlePriceBox = bundleWrapper.querySelector('#olla-bundle-price-box');
  const pickerTitle = bundleWrapper.querySelector('#olla-picker-title');
  const bundleAddBtn = bundleWrapper.querySelector('#olla-bundle-add');
  const currentPrice = bundleWrapper.querySelector('#olla-current-price');
  const priceNote = bundleWrapper.querySelector('#olla-price-note');
  const cards = bundleWrapper.querySelectorAll('.olla-card');

  const nativeVariantWrapper =
    document.querySelector('.product-block--variant_picker') ||
    document.querySelector('[data-dynamic-variants-enabled]') ||
    document.querySelector('.variant-wrapper') ||
    document.querySelector('.product__variants') ||
    document.querySelector('.product-single__form .variant-input-wrap') ||
    null;

  let activeBundle = 1;

  function formatMoney(cents) {
    const lei = cents / 100;
    return lei.toLocaleString('ro-RO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' lei';
  }

  function getSelectedTotalQty() {
    let total = 0;
    cards.forEach(card => {
      total += parseInt(card.querySelector('.olla-count').textContent, 10);
    });
    return total;
  }

  function getSelectedTotalPrice() {
    let total = 0;
    cards.forEach(card => {
      const qty = parseInt(card.querySelector('.olla-count').textContent, 10);
      const price = parseInt(card.dataset.price, 10);
      total += qty * price;
    });
    return total;
  }

  function resetQuantities() {
    cards.forEach(card => {
      card.querySelector('.olla-count').textContent = '0';
    });
  }

  function updateBundleState() {
    if (activeBundle === 1) {
      if (pickerContent) pickerContent.classList.add('hidden');
      if (bundlePriceBox) bundlePriceBox.classList.add('hidden');

      if (productForm) productForm.style.display = '';
      if (nativeVariantWrapper) nativeVariantWrapper.style.display = '';

      return;
    }

    if (pickerContent) pickerContent.classList.remove('hidden');
    if (bundlePriceBox) bundlePriceBox.classList.remove('hidden');

    if (productForm) productForm.style.display = 'none';
    if (nativeVariantWrapper) nativeVariantWrapper.style.display = 'none';

    const qty = getSelectedTotalQty();
    const fullPrice = getSelectedTotalPrice();
    const discount = activeBundle === 2 ? 10 : 15;
    const finalPrice = Math.round(fullPrice - (fullPrice * discount / 100));

    if (pickerTitle) {
      pickerTitle.textContent = activeBundle === 2 ? 'Selectează 2 Olla:' : 'Selectează 4 Olla:';
    }

    if (qty === 0) {
      currentPrice.textContent = 'Alege produsele';
      priceNote.textContent = activeBundle === 2
        ? 'Selectează 2 produse pentru set.'
        : 'Selectează 4 produse pentru set.';

      bundleAddBtn.textContent = 'Alege produsele';
      bundleAddBtn.disabled = true;
      return;
    }

    currentPrice.textContent = formatMoney(finalPrice);
    priceNote.textContent = 'Preț întreg: ' + formatMoney(fullPrice) + ' · Reducere ' + discount + '%';

    if (qty === activeBundle) {
      bundleAddBtn.textContent = activeBundle === 2
        ? 'Adaugă setul de 2 în coș'
        : 'Adaugă setul de 4 în coș';

      bundleAddBtn.disabled = false;
    } else {
      bundleAddBtn.textContent = 'Ai selectat ' + qty + ' din ' + activeBundle;
      bundleAddBtn.disabled = true;
    }
  }

  bundleButtons.forEach(button => {
    button.addEventListener('click', function () {
      bundleButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      activeBundle = parseInt(this.dataset.bundle, 10);
      resetQuantities();
      updateBundleState();
    });
  });

  cards.forEach(card => {
    const minus = card.querySelector('.olla-minus');
    const plus = card.querySelector('.olla-plus');
    const count = card.querySelector('.olla-count');

    plus.addEventListener('click', function () {
      const totalQty = getSelectedTotalQty();
      if (totalQty >= activeBundle) return;

      count.textContent = parseInt(count.textContent, 10) + 1;
      updateBundleState();
    });

    minus.addEventListener('click', function () {
      const current = parseInt(count.textContent, 10);
      if (current <= 0) return;

      count.textContent = current - 1;
      updateBundleState();
    });
  });

  async function addSelectedBundleToCart() {
    if (bundleAddBtn.disabled) return;

    const items = [];

    cards.forEach(card => {
      const qty = parseInt(card.querySelector('.olla-count').textContent, 10);

      if (qty > 0) {
        items.push({
          id: Number(card.dataset.variantId),
          quantity: qty,
          properties: {
            'Set Olla': activeBundle === 2 ? 'Set 2 buc -10%' : 'Set 4 buc -15%'
          }
        });
      }
    });

    try {
      bundleAddBtn.disabled = true;
      bundleAddBtn.classList.add('is-loading');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error('Nu am putut adăuga setul în coș.');
      }

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));

      setTimeout(function () {
        window.location.href = '/cart';
      }, 400);

    } catch (error) {
      console.error(error);
      alert('A apărut o problemă. Încearcă din nou.');
    } finally {
      bundleAddBtn.classList.remove('is-loading');
      updateBundleState();
    }
  }

  if (bundleAddBtn) {
    bundleAddBtn.addEventListener('click', addSelectedBundleToCart);
  }

  if (productForm) {
    productForm.addEventListener(
      'submit',
      function (e) {
        if (activeBundle !== 1) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      },
      true
    );
  }

  updateBundleState();
});